'use client';

import { atom } from 'jotai';

import type { Tenant } from '../../Entities/App/Tenants.entity';

export const tenantAtom = atom<Tenant | undefined>(undefined);
